import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { api, formatApiError } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Card } from "../components/ui/card";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const token = params.get("token") || "";

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 12) return toast.error("Password must be at least 12 characters.");
    if (pw !== confirm) return toast.error("Passwords do not match.");
    setBusy(true);
    try {
      await api.post("/auth/password/reset", { token, new_password: pw });
      toast.success("Password reset. Please sign in.");
      nav("/login");
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 bg-background" data-testid="reset-page">
      <Card className="p-8 lg:p-10 w-full max-w-md">
        <h1 className="font-serif text-3xl font-black tracking-tight">Reset password</h1>
        {!token ? (
          <p className="text-sm text-muted-foreground mt-4">Missing reset token. <Link to="/forgot-password" className="text-primary underline">Request a new link</Link>.</p>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div><Label>New password</Label><Input type="password" required minLength={12} value={pw} onChange={(e) => setPw(e.target.value)} data-testid="reset-pw" /></div>
            <div><Label>Confirm password</Label><Input type="password" required minLength={12} value={confirm} onChange={(e) => setConfirm(e.target.value)} data-testid="reset-confirm" /></div>
            <Button type="submit" className="w-full rounded-full" disabled={busy} data-testid="reset-submit">{busy ? "Resetting…" : "Set new password"}</Button>
          </form>
        )}
      </Card>
    </div>
  );
}
